import React from 'react';
import {CardType2} from './Cards';
import {Title} from './Title';

function CardContainer({Card, containerType, items, noTitle, type}) {
    return (
        <div className={`loading--${containerType}`}>
            {noTitle || <Title type={type} />}
            <div className={`loading--${containerType}--items`}>
                <div className={`loading--${containerType}--items--scroller`}>
                    {Array.from(new Array(items), (u, index) => (
                        <Card
                            key={`card--${String(index + 1).padStart(3, '0')}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export function CardStack({Card = CardType2, noTitle = false, type}) {
    return (
        <CardContainer
            Card={Card}
            containerType={'stack'}
            items={20}
            noTitle={noTitle}
            type={type}
        />
    );
}

export function Carousel({Card = CardType2, noTitle = false, type}) {
    return (
        <CardContainer
            Card={Card}
            containerType={'carousel'}
            items={4}
            noTitle={noTitle}
            type={type}
        />
    );
}
